<template>
  <div>
    <div class="loading" v-if="isLoading == true">
      <div class="sk-three-bounce">
        <div class="sk-child sk-bounce1"></div>
        <div class="sk-child sk-bounce2"></div>
        <div class="sk-child sk-bounce3"></div>
      </div>
    </div>
    <b-row class="mb-3" v-if="$can('export_jamimas_transaction')">
      <b-col sm>
        <div class="d-flex overflow-auto">
          <b-button 
            class="mr-3"
            variant="success" 
            @click="exportAll"
            :disabled="isLoadingButton || !isParams"
          >
            <div
              class="d-inline-flex sk-three-bounce custom-loading-bounce"
              v-if="isLoadingButton"
            >
              <div class="sk-child sk-bounce1"></div>
              <div class="sk-child sk-bounce2"></div>
              <div class="sk-child sk-bounce3"></div>
            </div>
            <span v-else>Export All Transactions</span>
          </b-button>
          <b-badge 
            class="badge-info-generate" 
            v-show="reportIsGenerated === true"
          >
            <p>
              <strong>Report is being processed,</strong> check the
              <router-link :to="{ name: 'Report Transaction History' }">
                Report Transaction History
              </router-link>
              menu periodically to download the file.
            </p>
          </b-badge>
        </div>
      </b-col>
    </b-row>
    <!-- Filter Text -->
    <b-row class="mb-3">
      <b-col sm>
        <div>
          <b-form-group
            class="mb-3"
            label="Search :"
            label-for="search"
            description="Searchable: Name, Email, JamimasId"
          >
            <b-input-group>
              <b-form-input
                id="search"
                type="search"
                v-model="filterText"
                placeholder="Name, Email, Jamimas ID"
              >
              </b-form-input>
              <b-input-group-append>
                <b-button
                 variant="secondary"
                 type="button"
                 @click="resetFilter"
                >
                  reset
                </b-button>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </div>
      </b-col>
    </b-row>
    <b-row class="mb-3">
      <!-- Transaction Status -->
      <b-col sm>
        <div>
          <b-form-group
           class="mb-3"
           label="Search By Transaction Status"
           label-for="label-status"
          >
            <b-form-select
              id="label-status"
              v-model="filterStatus"
              :options="statusOption"
            ></b-form-select>
          </b-form-group>
        </div>
      </b-col>
      <!-- Daterange -->
      <b-col sm>
        <div>
          <b-form-group
           class="mb-3"
           label="Date :"
           label-for="dateRange"
           :state="dateRangeState === false ? false : computedDateRequiredState"
          >
            <template #invalid-feedback>
              <span v-if="dateRangeState === false">
                The date range must be at least 1 day
              </span>
              <span v-else-if="computedDateRequiredState === false">
                Date range is required when using status filter without specific search
              </span>
            </template>
            <b-input-group>
              <b-input-group-prepend is-text>
                <i class="fa fa-calendar"></i>
              </b-input-group-prepend>
              <range-picker 
                id="dateRange"
                :start="startDate" 
                :end="endDate"
                :type="'clear'"
                :timePicker="false"
                :autoUpdate="false"
                @picker="doDateFilter">
              </range-picker>
              <b-input-group-append>
                <b-button 
                  type="button" 
                  variant="secondary" 
                  @click="resetDateFilter"
                >Reset</b-button>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </div>
      </b-col>
    </b-row>
    <b-row class="mb-3">
      <b-col sm>
        <b-button
          :disabled="stateButton"
          :style="buttonStyle"
          class="mb-2"
          @click="doFilter"
        >
          Apply Filter
        </b-button>
        <p class="mb-3" :style="{ color: 'rgba(115, 129, 143, 1)' }">
          Click button 'Apply Filter' to apply the filter
        </p>
      </b-col>
    </b-row>
    <div v-if="isLoadingTable">
      <b-skeleton-table
        :rows="10"
        :columns="11"
        :table-props="{ bordered: true }"
      >
      </b-skeleton-table>
    </div>
    <vuetable
      v-else
      ref="vuetable"
      :api-mode="false"
      :fields="fields"
      :per-page="limit"
      :data-manager="dataManager"
      @vuetable:load-error="handleLoadError"
      :no-data-template="isParams ? defaultTemplate : noDataTemplate"
    >
      <template slot="date-slot" slot-scope="prop">
        <span>{{ prop.rowData.created_at }}</span>
      </template>
      <template slot="id-slot" slot-scope="prop">
        <span>{{ prop.rowData.pawn_number }}</span>
      </template>
      <template slot="user-slot" slot-scope="prop">
        <span>{{ prop.rowData.users.name }} - {{ prop.rowData.users.email }}</span>
      </template>
      <template slot="gram-slot" slot-scope="prop">
        <span>{{ prop.rowData.gram }} Gram</span>
      </template>
      <template slot="cashout-slot" slot-scope="prop">
        <span>{{ prop.rowData.currency }}</span>
      </template>
      <template slot="tenor-slot" slot-scope="prop">
        <span>{{ prop.rowData.period_day }}</span>
      </template>
      <template slot="status-slot" slot-scope="prop">
        <span v-if="prop.rowData.status === 0">Diproses</span>
        <span v-else-if="prop.rowData.status === 1">Berjalan</span>
        <span v-else-if="prop.rowData.status === 2">Masa Tenggang</span>
        <span v-else-if="prop.rowData.status === 3">Gagal Bayar</span>
        <span v-else-if="prop.rowData.status === 4">Selesai</span>
        <span v-else-if="prop.rowData.status === 5">Ditolak</span>
      </template>
      <template slot="actions-slot" slot-scope ="prop">
        <div 
          class="custom-actions" 
          v-if="$can('detail_jamimas_transaction')"
        >
          <button 
            class="btn btn-success" 
            @click="onAction('detail-item', prop.rowData)"
          >
            Detail
          </button>
        </div>
      </template>
    </vuetable>
    <div
      v-show="isParams"
      class="vuetable-pagination ui basic segment grid"
    >
      <div class="wrapper-pagination-custom">
        <div class="pagination-custom-info">
          <p>{{ this.paginationInfo }}</p>
        </div>
        <div class="pagination-custom-button">
          <button :disabled="current_page === 1" @click="doMovePage('first')">
            <i
              v-if="current_page === 1"
              class="fa fa-angle-double-left disabled"
            ></i>
            <i v-else class="fa fa-angle-double-left"></i>
          </button>
          <button :disabled="current_page === 1" @click="doMovePage('prev')">
            <i v-if="current_page === 1" class="fa fa-angle-left disabled"></i>
            <i v-else class="fa fa-angle-left"></i>
          </button>
          <div>{{ this.current_page }}</div>
          <button :disabled="data.length < 10" @click="doMovePage('next')">
            <i v-if="data.length < 10" class="fa fa-angle-right disabled"></i>
            <i v-else class="fa fa-angle-right"></i>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import moment from 'moment';
import { required } from 'vuelidate/lib/validators';
import { validationMixin } from 'vuelidate';
import Vue from 'vue'
import Vuetable from 'vuetable-2/src/components/Vuetable'

Vue.use(Vuetable);

export default {
  components: {
    Vuetable
  },
  mixins: [validationMixin],
  validations: {
    startDate: { required },
    endDate: { required }
  },
  prop: {
    rowData: {
      type: Object,
      required: true
    },
    rowIndex: {
      type: Number
    }
  },
  data() {
    return {
      startDate: '',
      endDate: '',
      filterStatus: '',
      paginationInfo: '',
      filterText: '',
      dateRangeState: null,
      dateRequiredState: null,
      isLoading: false,
      isLoadingTable: false,
      isLoadingButton: false,
      isDateType: 'clear-auto',
      reportIsGenerated: false,
      data: [],
      page: 1,
      limit: 10,
      current_page: 1,
      sort: 'gold_pawn.created_at|desc',
      sortOrder: [
        {
          field: "date-slot",
          sortField: "gold_pawn.created_at",
          direction: "desc"
        }
      ],
      statusOption: [
        { value: '', text: 'Choose Status' },
        { value: 0, text: 'Diproses' },
        { value: 1, text: 'Berjalan' },
        { value: 2, text: 'Masa Tenggang' },
        { value: 3, text: 'Gagal Bayar' },
        { value: 4, text: 'Selesai' },
        { value: 5, text: 'Ditolak' }
      ],
      errors: {
        code: '',
        message: '',
        status: ''
      },
      moreParams: {},
      fields: [
        {
          name: 'date-slot',
          sortField: 'gold_pawn.created_at',
          title: 'Transaction Date'
        },
        {
          name: 'id-slot',
          sortField: 'gold_pawn.id',
          title: 'ID Jaminan Emas'
        },
        {
          name: 'user-slot',
          sortField: 'users.name',
          title: 'User'
        },
        {
          name: 'gram-slot',
          sortField: 'gold_pawn.gram',
          title: 'Gold Amount'
        },
        {
          name: 'cashout-slot',
          sortField: 'gold_pawn.currency',
          title: 'Cashout'
        },
        {
          name: 'tenor-slot',
          sortField: 'gold_pawn.period_day',
          title: 'Tenor (hari)'
        },
        {
          name: 'status-slot',
          sortField: 'gold_pawn.status',
          title: 'Status'
        },
        {
          name: 'actions-slot',
          title: 'Actions',
          titleClass: 'center aligned',
          dataClass: 'center aligned'
        }
      ],
      noDataTemplate:
        '<div class="text-center d-flex align-items-center justify-content-center" style="height: 120px;"><p>Use filter to show your data.</p></div>',
      defaultTemplate:
        '<div class="text-center d-flex align-items-center justify-content-center flex-column" style="height: 120px;"><p><strong>No results found.</strong></p><p>Please adjust your filter or search keywords</p></div>',
    }
  },
  computed: {
    computedDateRequiredState() {
      // Check if date is required based on active filters
      const hasStatusFilter = this.filterStatus !== "";
      const dateRangeEmpty = [this.startDate, this.endDate].every((f) => f === "");
      const hasFreetextFilter = this.filterText !== "";
      
      // Rule 3: If freetext is filled, date is not required (overrides rule 1)
      if (hasFreetextFilter) {
        return null;
      }
      
      // Rule 1: Date is required when status filter is active without freetext
      if (hasStatusFilter && dateRangeEmpty) {
        return false; // Invalid state
      }
      
      return null; // Valid state
    },
    stateButton() {
      const allFiltersEmpty = [
        this.filterStatus, this.filterText, this.startDate, this.endDate
      ].every((f) => f === "")
      
      // Disable if all filters are empty
      if (allFiltersEmpty) return true;
      
      // Disable if there's a date range validation error
      if (this.dateRangeState === false) return true;
      
      // Check filter types
      const hasStatusFilter = this.filterStatus !== "";
      const hasDateFilter = this.startDate !== "" || this.endDate !== "";
      const hasFreetextFilter = this.filterText !== "";
      
      // Rule 2 & 3: If freetext is filled, date is not required
      if (hasFreetextFilter) {
        return false;
      }
      
      // Rule 1: If has status filter without freetext, date is required
      if (hasStatusFilter && !hasDateFilter) {
        return true;
      }
      
      return false;
    },
    buttonStyle() {
      return {
        background: !this.stateButton ? "#7565F6" : "#c8ced3",
        color: !this.stateButton ? "#FFFFFF" : "inherit"
      };
    },
    isParams() {
      const params =
        // eslint-disable-next-line no-unused-vars
        Object.entries(this.moreParams).filter(([key, value]) => value)
          .length == 0;

      return !params && !this.isLoadingTable;
    },
  },
  watch: {
    // eslint-disable-next-line no-unused-vars
    data(newVal, oldVal) {
      if (
        this.$refs.vuetable &&
        typeof this.$refs.vuetable.refresh === "function"
      ) {
        this.$refs.vuetable.refresh();
      }
    }
  },
  methods : {
    onAction (action, data) {
      if (action == 'detail-item') {
        this.$router.push({
          name: 'Jamimas Transaction Detail',
          params: { id: data.id, user_id: data.users.id }
        })
      }
    },
    onFetch() {
      const newParams = Object.entries(this.moreParams)
        // eslint-disable-next-line no-unused-vars
        .filter(([_, value]) => value !== '' && value !== null && value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
        
      this.isLoadingTable = true;
      this.data = [];

      this.$http
        .get(
          `pawn-transaction?sort=${encodeURIComponent(this.sort)}&page=${this.page}&per_page=${this.limit}${newParams ? `&${newParams}` : ''}`
        )
        .then((response) => {
          const datas = response.data.data
          const datasCount = datas.length;
          const startIndex = (response.data.current_page - 1) * this.limit;
          const endIndex = Math.min(
            startIndex + this.limit,
            datasCount > 0 ? datasCount + startIndex : this.limit
          );

          this.data = datas
          this.current_page = response.data.current_page
          this.paginationInfo =
            datas.length > 0
              ? `Displaying ${startIndex + 1} to ${endIndex}`
              : "No relevant data";
          this.isLoadingTable = false
        })
        .catch(err => {
          this.isLoadingTable = false
          this.handleLoadError(err)
        })
    },
    dataManager(sortOrder, pagination) {
      let local = this.data;

      if (sortOrder.length > 0) {
        const newSort = `${sortOrder[0].sortField}|${sortOrder[0].direction}`;
        if (this.sort !== newSort) {
          this.sort = newSort;
          this.onFetch();
        }
      }

      pagination = this.$refs.vuetable.makePagination(
        local.length,
        this.limit
      );

      let from = pagination.from - 1;
      let to = from + this.limit;

      return {
        pagination: pagination,
        data: local.length > 0 ? _.slice(local, from, to) : []
      };
    },
    doMovePage(value) {
      this.$events.$emit('movePage', value)
    },
    onMovePage(eventData) {
      if (eventData === 'first') {
        this.page = 1;
        this.onFetch();
      } else if (eventData === 'prev') {
        this.page--;
        this.onFetch();
      } else {
        this.page++;
        this.onFetch();
      }
    },
    exportAll() {
      this.isLoadingButton = true;
      const queryParams = Object.entries(this.moreParams)
        // eslint-disable-next-line no-unused-vars
        .filter(([key, value]) => value !== '' && value !== null && value !== undefined)
        .map(
          ([key, value]) =>
            `${
              key == "start_from"
                ? "startDate"
                : key == "end_to"
                ? "endDate"
                : key
            }=${value}`
        )
        .join("&");

      this.$http.get(`pawn-export?sort=${encodeURIComponent(this.sort)}${queryParams && `&${queryParams}`}`)
        .then((result) => {
          if (result?.data?.meta?.code === 200) {
            this.reportIsGenerated = true
          }
          
          this.isLoadingButton = false;
        }).catch((error) => {
          this.handleLoadError(error);
        })
    },
    doFilter() {
      this.$events.$emit("apply-filter");
    },
    onFilterSet() {
      this.page = 1;
      this.moreParams = {
        start_from: this.startDate,
        end_to: this.endDate,
        filter: encodeURIComponent(this.filterText),
        status: this.filterStatus,
      };
      this.onFetch();
    },
    resetFilter () {
      this.filterText = ''
    },
    doDateFilter(value){
      this.$events.fire('date-set', value)
    },
    onDateSet(value)  {
      const startDate = moment(value.startDate);
      const endDate = moment(value.endDate);
      
      // Calculate the difference in days
      // const daysDiff = endDate.diff(startDate, 'days');
      
      // Must be at least 1 day difference
      // if (daysDiff < 1) {
      //   this.dateRangeState = false;
      //   return;
      // }
      
      // Valid range
      this.dateRangeState = null;
      this.startDate = startDate.format("YYYY-MM-DD");
      this.endDate = endDate.format("YYYY-MM-DD");
    },
    resetDateFilter () {
      this.startDate = ''
      this.endDate = ''
      this.dateRangeState = null
      // this.$events.$emit('date-filter-reset')
    },
    onDateFilterReset () {
      this.moreParams = Object.fromEntries(
        Object.entries(this.moreParams).filter(([key, value]) => {
          return [key, key !== "start_from" && key !== "end_to" ? value : ""];
        })
      );
    },
    handleLoadError(error) {
      const code = error.response.data.meta.code;
      const message = error.response.data.meta.message;

      this.errors.code = code;
      this.errors.message = message;
      this.errors.status = code;
      this.isLoading = false;
      this.isLoadingTable = false;
      this.isLoadingButton = false;

      if (this.errors.code == 401) {
        this.$swal
          .fire(
            "Your session expired!",
            "Your session has expired. Please login again to access this page!",
            "error"
          )
          .then(() => {
            this.$router.push("/login");
          });
      } else if (this.errors.code == 403) {
        this.$router.push("/403");
      } else {
        this.$swal.fire("An error occured", message, "error").then(() => {
          this.$router.reload();
        });
      }
    },
  },
  created() {
    this.$events.$on("apply-filter", this.onFilterSet);
    this.$events.$on('movePage', this.onMovePage);
    this.$events.$on('date-set', this.onDateSet);
    this.$events.$on('date-filter-reset', this.onDateFilterReset);
  },
  beforeDestroy() {
    this.$events.$off("apply-filter", this.onFilterSet);
    this.$events.$off('movePage', this.onMovePage);
    this.$events.$off('date-set', this.onDateSet);
    this.$events.$off('date-filter-reset', this.onDateFilterReset);
  }
}

</script>
<style>
.loading {
  position: fixed;
  z-index: 999;
  height: 2em;
  width: 2em;
  overflow: visible;
  margin: auto;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
}
.loading:before {
  content: '';
  display: block;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0,0,0,0.3);
}
.badge-info-generate {
  height: 32px;
  padding: 8px 12px;
  background-color: #fff3d3;
  border-radius: 4px;
  font-size: 12px;
  font-weight: normal;
  display: flex;
  align-items: center;
  justify-content: center;
}
.wrapper-pagination-custom {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #f9fafb;
}

.pagination-custom-button {
  display: flex;
}

.pagination-custom-button button {
  width: 28px;
  height: 47px;
  padding: 13px 16px;
  font-size: 1em;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #ffffff;
  border: solid rgba(0, 0, 0, 0.3);
}

.pagination-custom-button button:first-child {
  padding: 13px 16px 13px 30px;
  border-radius: 4px 0 0 4px;
  border-width: 1px 0 1px 1px;
}

.pagination-custom-button button:nth-child(2),
.pagination-custom-button button:last-child {
  font-size: 1.3em;
  border-width: 1px;
}

.pagination-custom-button button:last-child {
  border-radius: 0 4px 4px 0;
}

.pagination-custom-button button i.disabled {
  opacity: 0.6;
}

.pagination-custom-button div {
  width: 28px;
  height: 47px;
  font-size: 1em;
  font-weight: 500;
  background: #ffffff;
  border: solid rgba(0, 0, 0, 0.3);
  border-width: 1px 0 1px 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.custom-loading-bounce {
  width: 72px !important;
  height: 18px !important;
  margin: 0 !important;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
}
.custom-loading-bounce .sk-child {
  width: 6px !important;
  height: 6px !important;
  background: #ffffff !important;
}
</style>
<style src='spinkit/scss/spinkit.scss' lang='scss'></style>
